import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GhiseuModuleComponent } from './ghiseu-module.component';
import { AddGhiseuModuleComponent } from './add-ghiseu-module/add-ghiseu-module.component';
import { EditGhiseuModuleComponent } from './edit-ghiseu-module/edit-ghiseu-module.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ProgramareModulComponent } from './programare-modul/programare-modul.component';

@NgModule({
    declarations: [
        GhiseuModuleComponent,
        AddGhiseuModuleComponent,
        EditGhiseuModuleComponent,
        ProgramareModulComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [GhiseuModuleComponent],
})
export class GhiseuModuleModule { }
